import { v4 as uuid } from 'uuid'

import ObjectEditor from '../../object-editor'
import renderForm from './condition-base.pug'

# base class for trigger conditions
export default class ConditionBase extends ObjectEditor
  @i18nScope = "editor.conditions.base"
  @i18nScopeNamespace = "editor.conditions"

  renderForm: renderForm

  renderLocals: =>
    Object.assign(super(), conditionBaseT: ConditionBase.t.bind(ConditionBase))

  # generate a blank trigger object for this condition type
  @scaffold: ->
    Object.assign(_ref: uuid(), type: @type, actions: {}, @defaults)

  onSave: (newData)=>
    # do not overwrite actions in the store
    delete newData.actions

  finish: =>
    @save()
    @sceneEditor.editingActiveCondition = false
